import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plane } from "lucide-react";

// One-time intro: an airplane draws the logo and writes the name in cursive
// in the top-left, then flies away leaving the logo where the navbar sits.
export const IntroPlane = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("mr_intro_done")) return;
    setShow(true);
    sessionStorage.setItem("mr_intro_done", "1");
    const t = setTimeout(() => setShow(false), 5000);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[300] bg-navy-deep grain overflow-hidden"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          data-testid="intro-plane"
        >
          {/* Top-left drawing row: logo + cursive name */}
          <div className="absolute top-5 left-5 md:left-10 flex items-center gap-4 md:gap-6">
            {/* smoke trail spanning behind logo + name */}
            <motion.div
              className="absolute top-1/2 left-0 h-[3px] -translate-y-1/2 rounded-full"
              style={{ background: "linear-gradient(90deg, rgba(46,139,139,0.7) 0%, rgba(46,139,139,0) 100%)" }}
              initial={{ width: 0 }}
              animate={{ width: ["0px", "52vw"] }}
              transition={{ duration: 2.5, ease: "easeInOut" }}
            />

            {/* logo chip, revealed left -> right */}
            <motion.span
              className="relative inline-flex items-center"
              initial={{ clipPath: "inset(0 100% 0 0)" }}
              animate={{ clipPath: "inset(0 0% 0 0)" }}
              transition={{ duration: 1.5, ease: "easeInOut" }}
            >
              <img src="/images/logo-light.png" alt="Mamma Rosa" className="h-11 md:h-14 w-auto object-contain" />
            </motion.span>

            {/* cursive name, "written" after the logo — matched to the logo wordmark */}
            <motion.span
              className="relative leading-none whitespace-nowrap lowercase"
              style={{ fontFamily: "'Baloo 2', cursive", fontWeight: 800, fontSize: "clamp(2rem, 6vw, 4.25rem)" }}
              initial={{ clipPath: "inset(0 100% 0 0)" }}
              animate={{ clipPath: "inset(0 0% 0 0)" }}
              transition={{ duration: 1.4, delay: 1.7, ease: "easeInOut" }}
            >
              <span className="text-cream">mamma </span>
              <span style={{ color: "#E12626" }}>rosa</span>
            </motion.span>
          </div>

          {/* airplane: sweeps across drawing the logo and name, then climbs away */}
          <motion.div
            className="absolute text-gold"
            initial={{ left: "-8vw", top: "60px", rotate: 6, opacity: 1 }}
            animate={{
              left: ["-8vw", "24vw", "52vw", "120vw"],
              top: ["60px", "60px", "60px", "-150px"],
              rotate: [6, 6, 6, -28],
              opacity: [1, 1, 1, 0],
            }}
            transition={{ duration: 4.3, times: [0, 0.34, 0.72, 1], ease: "easeInOut" }}
          >
            <Plane size={38} strokeWidth={1.5} fill="currentColor" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
